// @ts-nocheck
import React from 'react';

import {
  AddOrganizationStructure,
  GetOrganizationStructure,
  GetOrganizationWithoutStructure,
  deleteOrganizationStructure
} from '@store/HR/Organizations/OrganizationStructureSice';
import useGetOrganizationWithoutStructure from '@hooks/HR/useGetOrganizationWithoutStructure';
import { useDispatch, useSelector } from 'react-redux';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import showConfirmation from '@components/Shared/Alert/Confirmation';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';

const OrgDetails = ({ data, onClose }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { OrganizationListWithoutStructure: dataStructure, loading, error } = useGetOrganizationWithoutStructure();

  const getIconByType = type => {
    const styles = {
      120: { icon: 'bi bi-people-fill', color: 'text-primary' }, // Department
      100: { icon: 'bi bi-grid', color: 'text-success' }, // Unit
      110: { icon: 'bi bi-buildings', color: 'text-danger' }, // Factory
      160: { icon: 'bi bi-tools', color: 'text-warning' }, // Workshop
      130: { icon: 'bi bi-box-seam', color: 'text-info' }, // Inventory
      150: { icon: 'bi bi-geo-alt', color: 'text-secondary' }, // Branch
      180: { icon: 'bi bi-file-earmark-text', color: 'text-dark' }, // Legal Entity
      30: { icon: 'bi bi-building', color: 'text-theme' }, // Company
      40: { icon: 'bi bi-briefcase', color: 'text-muted' }, // Office
      70: { icon: 'bi bi-map', color: 'text-success' }, // Region
      20: { icon: 'bi bi-house-door', color: 'text-danger' }, // Main Branch
      10: { icon: 'bi bi-diagram-3', color: 'text-warning' }, // Business Group
      210: { icon: 'bi bi-house', color: 'text-info' }, // Housing Complex
      60: { icon: 'bi bi-diagram-2', color: 'text-secondary' }, // Project
      140: { icon: 'bi bi-layers', color: 'text-dark' }, // Section
      170: { icon: 'bi bi-gear-wide', color: 'text-primary' }, // Enterprise Asset Management
      90: { icon: 'bi bi-heart-pulse', color: 'text-success' }, // Medical Service Provider
      200: { icon: 'bi bi-layout-split', color: 'text-danger' }, // Sub Section
      50: { icon: 'bi bi-boxes', color: 'text-warning' }, // Production
      80: { icon: 'bi bi-shop', color: 'text-info' } // Shop
    };

    // إذا لم يتم العثور على النوع، قم بإرجاع الإعدادات الافتراضية
    return styles[type] || { icon: 'bi bi-question-circle', color: 'text-body' };
  };

  const AddChild = async item => {
    try {
      const res = await dispatch(
        AddOrganizationStructure({
          organizationIdParent: data.id,
          organizationIdChild: item.id
        })
      ).unwrap();

      if (res.succeeded) {
        CustomAlert({ action: 'Add' });
        await Promise.all([dispatch(GetOrganizationStructure()), dispatch(GetOrganizationWithoutStructure())]);
      } else {
        throw new Error('Operation failed');
      }
    } catch (error) {
      CustomAlert({ action: 'Error' });
    }
  };

  const RemoveChild = async item => {
    debugger;
    showConfirmation(t('MsgConfirm'), async () => {
      try {
        let res = await dispatch(deleteOrganizationStructure(item.structureId)).unwrap();
        if (res.succeeded === true && res.data === true) {
          CustomAlert({ action: 'Delete', msg: 'تمت عملية الحذف بنجاح' });
          // جلب البيانات مرة واحدة بعد التحديث
          await Promise.all([dispatch(GetOrganizationWithoutStructure()), dispatch(GetOrganizationStructure())]);
        } else {
          CustomAlert({ action: 'Error' });
        }
      } catch (error) {
        CustomAlert({ action: 'Info' });
      }
    });
  };

  return (
    <>
      <Loading loading={loading} error={error}>
        <div className='fw-bold  bg-theme bg-opacity-25 d-flex justify-content-between p-2'>
          <div className='d-flex align-items-center'>
            <i className={`${getIconByType(data.type).icon} me-2 ${getIconByType(data.type).color} fa-lg`}></i>
            <>{data && data.name}</>
          </div>
          <button type='button' className='btn-close' onClick={onClose} />
        </div>

        <ul className='nav nav-tabs nav-tabs-v2 d-flex w-100 p-0'>
          {/* التبويب الأول: الوحدات غير المصنفة */}
          <li className='nav-item flex-fill text-center'>
            <a href='#unstructuredSections' className='nav-link active' data-bs-toggle='tab'>
              <i className='fa fa-folder-open me-2 text-theme'></i> الوحدات غير المصنفة
              {dataStructure?.length > 0 && <span className='badge bg-warning ms-2'>{dataStructure.length}</span>}
            </a>
          </li>
          {/* التبويب الثاني: الوحدات الفرعية */}
          <li className='nav-item flex-fill text-center'>
            <a href='#subSections' className='nav-link' data-bs-toggle='tab'>
              <i className='fa fa-sitemap me-2 text-theme'></i> الوحدات الفرعية
              {data?.childrenCount > 0 && <span className='badge bg-theme ms-2'>{data.childrenCount}</span>}
            </a>
          </li>
        </ul>

        <div className='tab-content px-1 py-4'>
          <div className='tab-pane fade show active' id='unstructuredSections'>
            <ul className='list-group'>
              {dataStructure &&
                dataStructure.map((item, index) => (
                  <li
                    className='list-group-item list-group-item-action d-flex justify-content-between align-items-center'
                    key={index}
                  >
                    {/* القسم الأول: الأيقونة + الاسم */}
                    <div>
                      <i
                        className={`${getIconByType(item.type).icon} me-2 ${getIconByType(item.type).color} fa-lg`}
                      ></i>
                      <span className='fw-bold'>{i18n.language === 'en' ? item.name : item.name2}</span>
                    </div>

                    {/* القسم الثاني: أزرار العمليات */}
                    <div>
                      <button className='btn btn-sm btn-outline-theme  ' onClick={() => AddChild(item)}>
                        <i className='fa fa-folder-plus fa-lg'></i>
                      </button>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
          <div className='tab-pane fade' id='subSections'>
            <ul className='list-group'>
              {data &&
                data.children &&
                data.children?.map((item, index) => (
                  <li
                    className='list-group-item list-group-item-action d-flex justify-content-between align-items-center'
                    key={index}
                  >
                    {/* القسم الأول: الأيقونة + الاسم */}
                    <div>
                      <i
                        className={`${getIconByType(item.type).icon} me-2 ${getIconByType(item.type).color} fa-lg`}
                      ></i>
                      <span className='fw-bold'>{i18n.language === 'en' ? item.name : item.name2}</span>
                    </div>

                    {/* القسم الثاني: أزرار العمليات */}
                    <div>
                      {item?.childrenCount === 0 ? (
                        <span className='badge bg-secondary mx-3'> No subdepartments</span>
                      ) : (
                        <span className='badge bg-theme mx-3'>
                          {' departments '}
                          {item.childrenCount}
                        </span>
                      )}
                      <button className='btn btn-sm btn-outline-danger' onClick={() => RemoveChild(item)}>
                        <i className='fa fa-trash fa-lg'></i>
                      </button>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </Loading>
    </>
  );
};

export default OrgDetails;
